import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator } from './components/sliders.js';
import { showMoreFaqs, accordion } from './components/accordion.js';
import { isUserLogged } from './components/user.js';

let previousLoader = 0;
let loadingBarValue = 0;
let contentLoaded = 0;
let bgRemoverTimer;
let urlImage;
let userHash;
let userToken;

const mainTop = document.querySelector('.page-header')
const bgRemovedPhotoPreviewContainer = document.querySelector('.preview-bg-removed-container');
const originalPhotoPreviewContainer = document.querySelector('.preview-og-image-container');
const sourceImagePreview = originalPhotoPreviewContainer.querySelector('img') || '';
const bgRemovedImagePreview = bgRemovedPhotoPreviewContainer.querySelector('img') || '';
const bgRemoverEndPointUrl = 'https:////api.desygner.com/business/background-removal?try';
const resizeEndPointUrl = 'https:////api.desygner.com/business/image/resize';
const mobileScreenSize = window.innerWidth <= 1280;
const redirectURL = 'https://desygner.com/create/templates';

const modalElements = {
  modalContainer: document.querySelector('.background-remover-preloader'),
  modal: document.querySelector('.preloader'),
  modalText: document.querySelector('.preloader .message'),
  modalButton: document.querySelector('.preloader [data-toggle="close-modal"]'),
  modalPercentageValue: document.querySelector('.preloader .percent-value'),
  modalPercentageContainer: document.querySelector('.preloader .bar-container'),
  modalPercentageBar: document.querySelector('.preloader .bar-container .bar')
}


document.addEventListener("DOMContentLoaded", async function () {
  await slickSliderGenerator('workflow_normal', '.workflow-normal-container');
  accordion('.faqs-cards');
  showMoreFaqs();
  getSVG();
  dragDropImage();
  initButtonAndUploadListeners();
  initializeEditButton();

});

const loadingBarUpdate = function() {
  modalElements.modalText.textContent = 'Removing background...';
  let increaseByTime = setInterval(function() {
    loadingBarValue = loadingBarValue + 1;
    modalElements.modalPercentageBar.setAttribute('style', `transform: scaleX(${loadingBarValue / 100} )`);
    modalElements.modalPercentageValue.textContent = Math.round(loadingBarValue) + '%';

    if (loadingBarValue >= 50) {
      clearInterval(increaseByTime);
      let increaseByBytes = setInterval(function() {
        let totalLoaded = loadingBarValue + (contentLoaded / 2);
        modalElements.modalPercentageBar.setAttribute('style', `transform: scaleX(${totalLoaded / 100} )`);
        modalElements.modalPercentageValue.textContent = Math.round(loadingBarValue + (contentLoaded / 2)) + '%';

        if (totalLoaded > 98) {
          clearInterval(increaseByBytes);
          modalElements.modalPercentageBar.setAttribute('style', `transform: scaleX(1)`);
          modalElements.modalPercentageValue.textContent = '100%';
          setTimeout(displayRemovedBgImage, 1000);
        }
      })
    }
  }, 100);
}

const checkIfUserIsLogged = () => {
  return document.cookie.includes('user_token') && document.cookie.includes('user_hash');
}

const resetLoadingBar = async () => {
  loadingBarValue = 0;
  contentLoaded = 0;
  modalElements.modalPercentageBar.setAttribute('style', `transform: scaleX(${loadingBarValue} )`);
  modalElements.modalPercentageValue.textContent = contentLoaded + '%';
}

const initializeEditButton = () => {
  const editOrRegister = document.querySelector('[data-toggle="gotoEditor"]')
  const editPhotoButton = document.querySelector('[data-action=bgRemoverEdit]');
  const registerUserButton = document.querySelector('[data-toggle="register-modal"]');

  isUserLogged && editOrRegister.addEventListener('pointerup', () => window.location.href = redirectURL)
  !isUserLogged && editOrRegister.addEventListener('pointerup', () => registerUserButton.click())
};

const initButtonAndUploadListeners = () => {
  const uploadInput = document.querySelector('#bg-remover-upload');
  const uploadButton = document.querySelector('[data-toggle="upload-image"]');
  uploadInput.addEventListener('change', function () { convertUserImageToBase64(this) })

  uploadButton.addEventListener('pointerdown', () => {
    uploadInput.value = '';
  });

  uploadButton.addEventListener('pointerup', () => {
    uploadInput.click();
  });

  modalElements.modalButton.addEventListener('pointerdown', () => resetModalContent());

  const closeButton = document.querySelectorAll('[data-toggle="close-bg-removed-container"]');
  closeButton.forEach(button => button.addEventListener('pointerup', () => {
    resetAssets();
    sessionStorage.removeItem('bgremovedUrl');
  }));

  const pointerEventsList = ['pointerenter', 'pointerleave', 'pointerdown'];
  const mobileMenu = document.querySelectorAll('.mobile-menu button');

  mobileMenu.forEach(mobileButton => {
    mobileButton.addEventListener('pointerenter', function () { this.classList.add('enter') });
    mobileButton.addEventListener('pointerleave', function () { this.classList.remove('enter') });

    mobileButton.dataset.toggle === 'display-original-image' && mobileButton.addEventListener('pointerdown', function () {
      toggleMobilePhotoContainer(originalPhotoPreviewContainer, 'active');
      this.classList.add('active');
    });

    mobileButton.dataset.toggle === 'display-bg-removed-image' && mobileButton.addEventListener('pointerdown', function () {
      toggleMobilePhotoContainer(bgRemovedPhotoPreviewContainer, 'active');
      this.classList.add('active');
    });

    const toggleMobilePhotoContainer = (targetPhoto, photoClass) => {
      mobileMenu.forEach(mobileButton => {
        checkForClassOnTarget(mobileButton, 'active') && mobileButton.classList.remove('active');
      });
      bgRemovedPhotoPreviewContainer.classList.remove('active');
      originalPhotoPreviewContainer.classList.remove('active');

      targetPhoto.classList.toggle(photoClass);
    }
  })

  const sampleButtonsContainer = document.querySelector('.sample-images-menu');
  const sampleButtons = document.querySelectorAll('.sample-button');

  pointerEventsList.forEach(pointerEvent => {
    pointerEvent !== 'pointerdown' && sampleButtonsContainer.addEventListener(pointerEvent, function () {
      pointerEvent === 'pointerenter' && this.classList.add('active');
      pointerEvent === 'pointerleave' && this.classList.remove('active');
    });

    sampleButtons.forEach(sampleButton => {
      sampleButton.addEventListener(pointerEvent, function () {
        if (pointerEvent === 'pointerdown') {
          const getSampleImageUrl = this.dataset.url;
          resetLoadingBar();

          removeBackgroundFromImage(getSampleImageUrl, 'GET')
            .then(imageToUpload => {
              const imageUrl = imageToUpload.responseURL;
              applyLoadedImagesToPreview(imageUrl, sourceImagePreview);

              return removeBackgroundFromImage(bgRemoverEndPointUrl, 'POST', imageUrl);
            })
            .then(imageFromApi => {
              removeBackgroundFromImage(getNoBgImageUrlFromApi(imageFromApi.response), 'GET');
              applyLoadedImagesToPreview(getNoBgImageUrlFromApi(imageFromApi.response), bgRemovedImagePreview);
              const downloadButton = document.querySelector('[data-action="download"]');

              fetch(getNoBgImageUrlFromApi(imageFromApi.response), {
                "method": "get",
              })
                .then(imageToShow => imageToShow.blob())
                .then(imageBlob => {
                  const imageBlobURL = URL.createObjectURL(imageBlob)
                  downloadButton.setAttribute('download', 'background-remover.png');
                  downloadButton.setAttribute('href', imageBlobURL);
                });
            })
            .catch(error => displayErrorMsg(error));

        } else if (pointerEvent === 'pointerenter') {
          this.classList.add('active');

        } else if (pointerEvent === 'pointerleave') {
          this.classList.remove('active');

        };
      });
    });
  });
};

const displayErrorMsg = (errorCode) => {
  const elementsToBeHidden = [modalElements.modal, modalElements.modalPercentageContainer, modalElements.modalPercentageValue]
  elementsToBeHidden.forEach(element => element.classList.add('invisible'));

  modalElements.modalText.textContent = checkConnectionRequestStatus(errorCode);
  modalElements.modalButton.classList.toggle('active');
  modalElements.modal.classList.add('error');
}

const dragDropImage = () => {
  const dropArea = document.querySelector('.drop-area');
  const dropAreaBg = document.querySelector('.dragNdrop-background')
  const dropAreaIcon = document.querySelector('.drop-area .dagNDrop-icon')

  dropArea.addEventListener('dragenter', event => {
    event.preventDefault();
    resetLoadingBar();
    dropAreaBg.classList.add('active');
    dropAreaIcon.classList.add('active');
  });

  dropArea.addEventListener('dragover', event => event.preventDefault());

  dropArea.addEventListener('drag', event => {
    event.preventDefault();
    dropAreaBg.classList.add('active');
    dropAreaIcon.classList.add('active');
  });

  dropAreaBg.addEventListener('drop', event => {
    event.preventDefault();
    const dataTransfer = event.dataTransfer;
    dropAreaBg.classList.remove('active');
    dropAreaIcon.classList.remove('active');
    displayModal()
    convertUserImageToBase64(dataTransfer);
  })

  dropAreaBg.addEventListener('dragleave', event => {
    event.preventDefault();
    dropAreaBg.classList.remove('active');
    dropAreaIcon.classList.remove('active');
  });
}

const checkForClassOnTarget = (target, targetClass) => { return target.classList.contains(targetClass); }
const convertUserImageToBase64 = input => {
  new Promise((resolve, reject) => {
    resetLoadingBar();
    displayModal();
    const userReader = new FileReader();
    userReader.addEventListener('load', () => {
      const convertedImage = userReader.result;
      applyLoadedImagesToPreview(convertedImage, sourceImagePreview);
      resolve(convertedImage);
    });

    userReader.addEventListener('error', () => reject(userReader.status));
    userReader.readAsDataURL(input.files[0])
  })
    .then((base64ImageUrl) => {
      return removeBackgroundFromImage(bgRemoverEndPointUrl, 'POST', base64ImageUrl)
    })
    .then(imageFromApi => {
      removeBackgroundFromImage(getNoBgImageUrlFromApi(imageFromApi.response), 'GET', '', 'userImage');
      applyLoadedImagesToPreview(getNoBgImageUrlFromApi(imageFromApi.response), bgRemovedImagePreview);
      const downloadButton = document.querySelector('[data-action="download"]');

      fetch(getNoBgImageUrlFromApi(imageFromApi.response), {
        "method": "get",
      })
        .then(imageToShow => imageToShow.blob())
        .then(imageBlob => {
          const imageBlobURL = URL.createObjectURL(imageBlob)
          downloadButton.setAttribute('download', 'background-remover.png');
          downloadButton.setAttribute('href', imageBlobURL);
        })
    })
    .catch(error => displayErrorMsg(error));
}

const removeBackgroundFromImage = (url, method, body, loaderType) => {
  window.scrollTo(0, 0);
  const requestConnection = new XMLHttpRequest();
  return new Promise((resolve, reject) => {
    requestConnection.open(method, url);
    postHeader(requestConnection, method);

    requestConnection.addEventListener('loadstart', () => {
      if (loadingBarValue < 1) {
        loadingBarUpdate();
        displayModal();
      }
    });

    requestConnection.addEventListener('progress', function loadOnProgress(loadedElement) {
      if (method !== 'POST') {
        let percentage = (loadedElement.loaded / loadedElement.total) * 100;
        contentLoaded = loaderType === 'userImage'
          ? percentage
          : previousLoader + (percentage / 2);

      }
    });

    requestConnection.addEventListener('error', () => {
      return reject(requestConnection.status)
    });

    requestConnection.addEventListener('load', function loadHasFinished(loadedElement) {
      if (method !== 'POST') {
        let percentage = (loadedElement.loaded / loadedElement.total) * 100;
        let barLoadedValue = loadingBarValue / 100;
        contentLoaded = loaderType === 'userImage'
          ? percentage
          : previousLoader + (percentage / 2);

        previousLoader = ((loadedElement.loaded / loadedElement.total) * 100) / 2;
      }
      return checkConnectionRequestStatus(requestConnection.status) && resolve(requestConnection);

    });

    requestConnection.send(method === 'POST' ? JSON.stringify(buildPostRequest(body)) : '');
  });
}

const checkConnectionRequestStatus = (connStatus) => {
  if (connStatus >= 200 && connStatus <= 299) return connStatus;
  else if (connStatus >= 400 && connStatus <= 499) return 'File not found, please contact our support.'
  else if (connStatus >= 500 && connStatus <= 599) return 'Server unavailable, please contact our support.'
  else return 'Error while uploading your file, please contact our support.';

}

const displayRemovedBgImage = async () => {
  await toggleTopContent();
  checkIfUserIsLogged() && resizeImages();
  mainTop.classList.toggle('background-remover-active');
  modalElements.modalContainer.classList.remove('active');
  await resetLoadingBar();
}

const postHeader = (request, method) => {
  if (method === 'POST') return request.setRequestHeader('Content-Type', 'application/json');
}

const buildPostRequest = (bodyData) => {
  const hasImageURL = bodyData.includes('https');
  let requestBody = { sync: true,  };
  requestBody[hasImageURL ? 'image' : 'image_base64'] = bodyData;
  return requestBody;
}

const getNoBgImageUrlFromApi = imagesFromApiBgRemover => {
  const parsedData = JSON.parse(imagesFromApiBgRemover);
  return parsedData.expected_output;
}

const applyLoadedImagesToPreview = (imageUrl, imageContainer) => {
  document.querySelector('html').classList.remove('no-scroll');
  imageContainer.setAttribute('src', imageUrl);
  addImageDataToSessionStorage(imageUrl);
  urlImage = imageUrl;
}

const addImageDataToSessionStorage = (imageUrl) => {
  const originalLoadedImage = new Image();
  originalLoadedImage.src = imageUrl;
  originalLoadedImage.addEventListener('load', () => {
    sessionStorage.removeItem('bgremovedUrl');
    const imageData = { url: imageUrl, width: originalLoadedImage.width, height: originalLoadedImage.height };
    sessionStorage.setItem('bgremovedUrl', JSON.stringify(imageData));
  });
};

const displayModal = () => {
  document.querySelector('.background-remover-preloader').classList.add('active');
  document.querySelector('html').classList.add('no-scroll')
  modalElements.modal.classList.add('active');
}

const toggleTopContent = async () => {
  const topContent = document.querySelectorAll('.content-display-original, .content-display-background-removed');
  topContent.forEach( async content => content.classList.toggle('active'));
  defaultView();
}

const resizeImages = () => {
  document.cookie.split(';').filter( cookie => {
    if (cookie.includes('user_hash')) return userHash = cookie;
    if (cookie.includes('user_token')) return userToken = cookie;
  })

  const authorization = btoa(`${userToken.split('=')[1]}:${userHash.split('=')[1]}`);
  const resizeHeaders = new Headers();
  resizeHeaders.append("Accept", "application/json");
  resizeHeaders.append("Authorization", `Basic ${authorization}`);
  const image = JSON.parse(sessionStorage.getItem('bgremovedUrl'));

  const formdata = new FormData();
  formdata.append("src", image.url);

  const resizeRequestOptions = {
    method: 'POST',
    headers: resizeHeaders,
    body: formdata,
    redirect: 'follow'
  };

  fetch(resizeEndPointUrl, resizeRequestOptions)
    .then(response => response.text())
    .catch(error => checkConnectionRequestStatus(error.status));
}

const defaultView = () => {
  const removedBgImageButton = document.querySelector('[data-toggle="display-bg-removed-image"]');
  const originalImageButton = document.querySelector('[data-toggle="display-original-image"]');

  removedBgImageButton.classList.add('active');
  originalImageButton.classList.remove('active');

  bgRemovedPhotoPreviewContainer.classList.add('active');
  mobileScreenSize
  ? originalPhotoPreviewContainer.classList.remove('active')
  : originalPhotoPreviewContainer.classList.add('active');
}

const resetAssets = () => {
  const bgPreviewContent = document.querySelectorAll('.content-display-original, .content-display-background-removed');
  const previews = document.querySelectorAll('.background-original-preview .image-container, .background-removed-preview .image-container ');

  mainTop.classList.toggle('background-remover-active');
  bgPreviewContent.forEach(assets => assets.classList.toggle('active'));
  previews.forEach(previewImages => previewImages.removeAttribute('src'));
  previousLoader = 0;
}

const resetModalContent = () => {
  const modal = modalElements.modalContainer;
  const allActiveChildren = modal.querySelectorAll('.resetable');
  modal.classList.add('invisible');
  previousLoader = 0;

  allActiveChildren.forEach(visibleElements => {
    visibleElements.classList.add('invisible');
    visibleElements.classList.remove('error');
  });
}
